import * as routes from '../../../constants/routes';
import { HOT_YOTER_DEFAULT_SLUG } from '../constants';

export const normalizeCategoryLabel = (value) => (
    String(value ?? '').trim().replace(/\s+/g, '_')
);

export const isHotYoterBenefitsCategory = (titleOrUrlName) => (
    normalizeCategoryLabel(titleOrUrlName) === HOT_YOTER_DEFAULT_SLUG
);

export const getHotYoterBenefitsRoute = () => `${routes.hot_yoter}/${HOT_YOTER_DEFAULT_SLUG}`;

export const resolveHotYoterCategoryRoute = (crumb = {}) => {
    if (isHotYoterBenefitsCategory(crumb.text)) {
        return getHotYoterBenefitsRoute();
    }

    const route = crumb.route;

    if (!route) {
        return route;
    }

    const categoryPathMatch = route.match(/\/קטגוריה\/[^/]+\/([^/?#]+)/);

    if (categoryPathMatch && isHotYoterBenefitsCategory(categoryPathMatch[1])) {
        return getHotYoterBenefitsRoute();
    }

    return route;
};

export const getCategoryBreadcrumbRoute = ({ title, id, url_name: urlName } = {}) => {
    if (isHotYoterBenefitsCategory(title) || isHotYoterBenefitsCategory(urlName)) {
        return getHotYoterBenefitsRoute();
    }

    const resolvedUrlName = urlName ?? title?.replace(/ /g, '_');

    return `${routes.category}/${id}/${resolvedUrlName}`;
};
